import { PackageDetails } from '@models/package'
import * as React from 'react'
import { Card } from 'reactstrap'
import { PackageDetailsBaseInformationForm } from '@modules/package/details/information/base/form'
import { PackageDetailsBaseInformationTable } from '@modules/package/details/information/base/table'
import { useToggle } from 'rooks'

interface Props {
  packageDetails: PackageDetails
}

export const PackageDetailsBaseInformation: React.FC<Props> = ({ packageDetails }) => {
  const [isEditing, setEdit] = useToggle()

  const toggleEdit = () => {
    setEdit(edit => !edit)
  }

  return (
    <Card data-testid="package-details-base-info">
      {isEditing ? (
        <PackageDetailsBaseInformationForm toggleEdit={toggleEdit} packageDetails={packageDetails} />
      ) : (
        <PackageDetailsBaseInformationTable toggleEdit={toggleEdit} packageDetails={packageDetails} />
      )}
    </Card>
  )
}
